var $mcGoal = {'settings':{'uuid':'f4eedf0ce1021dc12d03a3abb','dc':'us2'}};
(function() {
	 var sp = document.createElement('script'); sp.type = 'text/javascript'; sp.async = true; sp.defer = true;
	sp.src = ('https:' == document.location.protocol ? 'https://s3.amazonaws.com/downloads.mailchimp.com' : 'http://downloads.mailchimp.com') + '/js/goal.min.js';
	var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(sp, s);
})();
